export default { sha: 'a80b5a65b92dcfbac19f633de9918f17331048d5', buildNumber: 'undefined' }
